'use strict';

function applyButtonFix() {
  const buttons = document.querySelectorAll(
    '.btn-buy-big, .btn-buy, .btn-small, .btn-more, .btn-clear'
  );
  buttons.forEach(button => {
    if (!button.classList.contains('btn')) {
      button.classList.add('btn');
    }
  });
}

module.exports = function applyGIGFixes() {
  applyButtonFix();
};
